import { toast } from "sonner";

// COPY SAYS "COPIED" ONLY WHEN IT COPIED — the clipboard can be refused (an older tablet, a non-secure page)
export async function copyText(t, done = "Copied to clipboard") {
  try {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(t);
    } else {
      const ta = document.createElement("textarea");
      ta.value = t; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      if (!ok) throw new Error("copy refused");
    }
    toast.success(done);
  } catch {
    toast.error("Couldn't copy — press and hold the number to copy it by hand.");
  }
}
